import Glide from '@glidejs/glide'

export default class GlideConfig {
  constructor() {
    if (document.querySelector('.front-page__carousel')) {
      this.frontPageCarousel = {
        type: 'carousel',
        perView: 1,
        autoplay: 3000
      }

      new Glide('.front-page__carousel', this.frontPageCarousel).mount()
    }

    if (document.querySelector('.reference__carousel')) {
      this.referenceCarousel = {
        type: 'carousel',
        perView: 3,
        gap: 50,
        breakpoints: {
          1024: { perView: 2 },
          800: { perView: 1 }
        }
      }

      new Glide('.reference__carousel', this.referenceCarousel).mount()
    }
  }
}
